import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {field, utils} from "@mc/mc-legacy";
import Role from "../../api/gen/qsign/types/Role";
import * as podepisujiciActions from "../../actions/podepisujiciActions";


const items = [
    {id: Role.PODEPISUJICI, name: "Podepisující"},
    {id: Role.SCHVALUJICI, name: "Schvalující"},
    {id: Role.PREDKLADATEL, name: "Předkladatel"},
];

/**
 * field pro filtrování uživatelů podle rolí
 */
class QsignRoleField extends Component<any> {
    static propTypes = {
        empty: PropTypes.bool,
        value: PropTypes.string,
        onChange: PropTypes.func,
    };
    static defaultProps = {
        empty: true,
    };


    render() {
        const {dispatch, empty, onChange, value, ...componentProps} = this.props;

        return (
            <field.Autocomplete
                {...componentProps}
                initialValue={value}
                getItemName={(item) => (item ? item.name : "")}
                items={items}
                onChange={(item) => onChange(item)}
                placeholder={'Zafiltrovat roli'}
                useIdAsValue
            />
        );
    }
}

export default connect((state) => {
    return {
        roleFilter: utils.storeFromArea(state, podepisujiciActions.SELECTED_ROLE_TO_FILTER),
    };
})(QsignRoleField);
